// extracted by mini-css-extract-plugin
export default {"aiInsightsText":"Efszvm"};